export default {
  title: 'Ruokalistan muokkaushistoria',
  subtitle: 'Katso, kuka muutti hintoja, saatavuutta ja näkyvyyttä kohteelle {{company}} — ja milloin.',
  filters: {
    type: {
      label: 'Tyyppi',
    },
    item: {
      placeholder: 'Kaikki kohteet',
    },
    event: {
      label: 'Tapahtuma',
    },
  },
  columns: {
    when: 'Milloin',
    who: 'Muuttanut',
    type: 'Tyyppi',
    item: 'Kohde',
    event: 'Tapahtuma',
    changes: 'Muutokset',
  },
  types: {
    product: 'Tuote',
    modifier: 'Muokkain',
    category: 'Kategoria',
    modifier_group: 'Lisävalintaryhmä',
    menu: 'Menu',
  },
  events: {
    created: 'Luotu',
    updated: 'Päivitetty',
    deleted: 'Poistettu',
  },
  fields: {
    name: 'Nimi',
    description: 'Kuvaus',
    price: 'Hinta',
    is_available: 'Saatavuus',
    is_visible: 'Näkyvyys',
    is_available_for_pickup: 'Nouto saatavilla',
    is_available_for_delivery: 'Toimitus saatavilla',
    tax_category_id: 'Verokategoria',
    schedule: 'Näkyvissä ajat',
    is_required: 'Pakollinen',
    max_count: 'Valintoja enintään',
  },
  // A dish's price per order method that a price change worked out again (QA24): each its own line.
  order_method_prices: {
    pickup: 'Noutohinta',
    delivery: 'Toimitushinta',
    dine_in: 'Paikalla syömisen hinta',
    room_service: 'Huonepalvelun hinta',
  },
  booleans: {
    on: 'Saatavilla',
    off: 'Ei saatavilla',
    yes: 'Kyllä',
    no: 'Ei',
  },
  schedule: {
    always: 'Aina',
    every_day: 'Joka päivä',
  },
  pagination: {
    previous: 'Edellinen',
    next: 'Seuraava',
  },
  causers: {
    undo: 'Kumoa',
    orders_terminal: 'Tilauspääte',
    approved_by: {
      amigo: 'Amigo, hyväksynyt {{name}}',
      assistant: 'Avustaja, hyväksynyt {{name}}',
    },
  },
  // Only our team sees it (the Amigo log is FoodAmigos-internal).
  open_agent_log: 'Avaa Amigo-lokissa',
  system: 'Järjestelmä',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Valikon muokaushistorian lataaminen epäonnistui',
  },
};
